var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6365 8.00038L6.8001 5.44258V10.5582L10.6365 8.00038ZM12.4257 8.24998L6.0663 12.4896C6.02112 12.5196 5.96864 12.5369 5.91443 12.5395C5.86023 12.5421 5.80634 12.5299 5.7585 12.5043C5.71066 12.4787 5.67066 12.4406 5.64277 12.394C5.61487 12.3475 5.60013 12.2942 5.6001 12.24V3.76078C5.60013 3.70652 5.61487 3.65328 5.64277 3.60673C5.67066 3.56018 5.71066 3.52207 5.7585 3.49646C5.80634 3.47084 5.86023 3.45869 5.91443 3.46128C5.96864 3.46387 6.02112 3.48112 6.0663 3.51118L12.4257 7.75078C12.4668 7.77818 12.5005 7.8153 12.5238 7.85884C12.5471 7.90238 12.5593 7.951 12.5593 8.00038C12.5593 8.04977 12.5471 8.09839 12.5238 8.14193C12.5005 8.18547 12.4668 8.22259 12.4257 8.24998Z",
    fill: "#626268"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.bc3ccfb2f8aa5c34538682d703745a43.svg";
export { ForwardRef as ReactComponent };